import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = ["onClick"];
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import TUICore, { TUIConstants } from '@tencentcloud/tui-core';
import { ref, onMounted, onUnmounted } from '../../../adapter-vue';
import Icon from '../../common/Icon.vue';
import backSVG from '../../../assets/icon/back.svg';
import { isPC } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['closeChat'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var currentConversation = ref();
    var currentConversationName = ref('');
    var typingStatus = ref(false);
    var groupID = ref('');
    var extensions = ref([]);
    onMounted(() => {
      TUIStore.watch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdated
      });
      TUIStore.watch(StoreName.CHAT, {
        typingStatus: onTypingStatusUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdated
      });
      TUIStore.unwatch(StoreName.CHAT, {
        typingStatus: onTypingStatusUpdated
      });
    });
    var closeChat = conversationID => {
      emits('closeChat', conversationID);
    };
    var handleExtensions = item => {
      var _item$listener$onClic, _item$listener;
      (_item$listener$onClic = (_item$listener = item.listener).onClicked) === null || _item$listener$onClic === void 0 || _item$listener$onClic.call(_item$listener, {
        groupID: groupID.value
      });
    };
    function onCurrentConversationUpdated(conversation) {
      var _currentConversation$, _currentConversation$2, _currentConversation$3;
      var isGroup = (conversation === null || conversation === void 0 ? void 0 : conversation.type) === TUIChatEngine.TYPES.CONV_GROUP;
      if (isGroup && ((_currentConversation$ = currentConversation.value) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.conversationID) !== (conversation === null || conversation === void 0 ? void 0 : conversation.conversationID)) {
        extensions.value = TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.CHAT_HEADER.EXT_ID, {
          filterManageGroup: !isGroup
        });
      }
      if (!isGroup) {
        extensions.value = [];
      }
      currentConversation.value = conversation;
      groupID.value = (_currentConversation$2 = currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.groupProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.groupID;
      currentConversationName.value = currentConversation === null || currentConversation === void 0 || (_currentConversation$3 = currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.getShowName();
    }
    function onTypingStatusUpdated(status) {
      typingStatus.value = status;
      if (typingStatus.value) {
        currentConversationName.value = TUITranslateService.t('TUIChat.对方正在输入');
      } else {
        var _currentConversation$4;
        currentConversationName.value = ((_currentConversation$4 = currentConversation.value) === null || _currentConversation$4 === void 0 ? void 0 : _currentConversation$4.getShowName()) || '';
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['chat-header', !_unref(isPC) && 'chat-header-h5'])
      }, [_withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['chat-header-back', !_unref(isPC) && 'chat-header-h5-back']),
        onClick: _cache[0] || (_cache[0] = $event => closeChat(_unref(currentConversation).conversationID))
      }, [_createVNode(Icon, {
        file: _unref(backSVG)
      }, null, 8, ["file"])], 2), [[_vShow, !_unref(isPC)]]), _createElementVNode("div", {
        class: _normalizeClass(['chat-header-content', !_unref(isPC) && 'chat-header-h5-content'])
      }, _toDisplayString(_unref(currentConversationName)), 3), _createElementVNode("div", {
        class: _normalizeClass(['chat-header-setting', !_unref(isPC) && 'chat-header-h5-setting'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extensions), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: _withModifiers($event => handleExtensions(item), ["stop"])
        }, [_createVNode(Icon, {
          file: item.icon
        }, null, 8, ["file"])], 8, _hoisted_1);
      }), 128))], 2)], 2);
    };
  }
});